import React from 'react'

import { createContext, useContext, useEffect, useState } from 'react'

const SidebarContext = createContext(undefined)

export function SidebarProvider({ children }) {
  // Initialize from localStorage if available, otherwise default to true
  const [sideMenuVisible, setSideMenuVisible] = useState(true)

  // Load the initial state from localStorage on mount
  useEffect(() => {
    const storedValue = localStorage.getItem('sideMenuVisible')
    setSideMenuVisible(storedValue !== null ? storedValue === 'true' : true)
  }, [])

  const toggleSidebar = () => {
    const newValue = !sideMenuVisible
    localStorage.setItem('sideMenuVisible', String(newValue))
    setSideMenuVisible(newValue)
  }

  return <SidebarContext.Provider value={{ sideMenuVisible, toggleSidebar }}>{children}</SidebarContext.Provider>
}

export function useSidebar() {
  const context = useContext(SidebarContext)
  if (context === undefined) {
    throw new Error('useSidebar must be used within a SidebarProvider')
  }
  return context
}
